import StylishBox from 'src/ui-kit/StylishBox/StylishBox';
import Skeleton from '../../../../components/Loaders/Skeleton/Skeleton';

const AddressManagementBarSkeleton = () => {
  return (
    <StylishBox
      className='AddressManagementBarSkeleton'
      sbs={{
        height: {
          general: '72px',
          desktopTablet: '80px',
        },
      }}
    >
      <Skeleton />
    </StylishBox>
  );
};

export default AddressManagementBarSkeleton;
